import { RouteConfig } from "vue-router";

export const REmployeeProfilePersonalInfo: RouteConfig = {
  path: "personal-info",
  name: "EmployeeProfilePersonalInfo",
  component: () =>
    import(
      /* webpackChunkName: "employee-profile-personal-info" */
      "./VEmployeeProfilePersonalInfo.vue"
    ),
  meta: {
    title: "My Profile",
    label: "personal info",
    tabName: "employee_personal_info",
    alias: "personal_info",
  },
};
